<template>
    <div class="advisory-status-setting">
				<StatusMenu :tab_name="'advisoryStatus'"  v-if="_gAuth.isAppSas()"/>
        <CreateNewAdvisoryStatusModal :create_new_advisory_status.sync="modals.create_new_advisory_status"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Advisory Status Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <AdvisoryStatusTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import StatusMenu from '@/views/Configurations/StatusMenu'
import AdvisoryStatusTable from '@/views/Configurations/AdvisoryStatusSettings/AdvisoryStatusTable'
import CreateNewAdvisoryStatusModal from '@/views/Configurations/AdvisoryStatusSettings/AdvisoryStatusModals/CreateNewAdvisoryStatusModal'

export default {
    components: {
        AdvisoryStatusTable,
        RouteBreadCrumb,
        CreateNewAdvisoryStatusModal,
				StatusMenu
    },
    data() {
        return {
            modals: {
                create_new_advisory_status: false
            }
        }
    },
    methods: {
        openModal() {
            this.modals.create_new_advisory_status = true;
        },
        closeModal(){
            this.modals.create_new_advisory_status = false;
        },
    }
}
</script>